// 1. 引入
import axios from "axios";
import Cookies from 'js-cookie';
import config from '../assets/js/config';

// 配置 cookie 信息
let cookieStr = null;
let cookieObj = null;

// 2. 配置信息
let baseUrl = process.env.NODE_ENV === 'production' ? 'https://api.inx-activity.com' : 'http://api.inx-activity.com';
let axiosConfig = {
    // 每次请求的协议、IP地址。  设置该配置后，每次请求路径都可以使用相对路径，例如"/admin/login"
    baseURL: baseUrl,
    // 请求超时时间
    timeout: 30000,
    // header
    headers: {
        // 每次请求携带cookie
        "withCredentials": false,
        "Access-Control-Allow-Origin": "*",
        // "Content-Type": "application/x-www-form-urlencoded",
        // "Content-Type": "application/form-data",
    },
    // withCredentials: false
}

// 3. 创建实例
const instance = axios.create(axiosConfig);
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

instance.interceptors.request.use(
    request => {
        cookieStr = Cookies.get(config.cookieName) || null;
        // console.log('cookieStr = ', cookieStr);
        if(cookieStr == "") {
            // console.log('没有 token, 不发请求');
            return;
        }
        cookieObj = cookieStr ? JSON.parse(cookieStr) : null;
        
        // console.log('request = ', request);
        request.headers['p_xtk'] = cookieObj ? cookieObj.ref_token : '';
        request.headers['p_xuid'] = cookieObj ? cookieObj.ref_uid : '';
        let data = null;
        let fd  = new FormData();

        try {
            data = JSON.parse(request.data);
            for(let key in data) {
                fd.append(key, data[key]);
            }
            request.data = fd;
        }catch(e){
            return request;
        }

        return request;
    },

    response => {
        // console.log('response = ', response);
        // if(response.data.)
        return response;
    },

    error => {
        // console.log('axios interceptors error:', error);
    }
);


// 4. 导出
export default instance